import { useRef, useState, useEffect } from "react";
import { Divider, Flex, Tooltip } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import { useAtom, useAtomValue } from "jotai";
import cls from "classnames";
import useRouteQuery from "@/hooks/useRouteQuery";
import BtnAdd from "@/components/BtnAdd";
import styles from "./index.module.scss";

import { isWorkLeftPanelOpenAtom, userClickedAtom } from "@/atom/drawBoard";
import useUpdateCourseSettings from "@/hooks/useUpdateCourseSettings";
import { isMobileAndOldVersion } from "@/utils/app";

function LeftHeader({
  selectedBgType,
  title,
  courseId,
  userInfo,
  gotUserInfo,
  isLessonEnd,
}: {
  selectedBgType: string;
  title: string | undefined;
  courseId: number | undefined;
  userInfo: any;
  gotUserInfo: boolean;
  isLessonEnd: boolean | undefined;
}) {
  let navigate = useNavigate();
  const { lessonId = "" } = useRouteQuery();
  const titleRef = useRef<HTMLButtonElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const userClicked = useAtomValue(userClickedAtom);
  const [isWorkLeftPanelOpen, setIsWorkLeftPanelOpen] = useAtom(
    isWorkLeftPanelOpenAtom
  );

  const { updateLeftPanelStatus } = useUpdateCourseSettings();
  const location = useLocation();

  const isCourse =
    location.pathname === "/course/" || location.pathname === "/course";

  const isWork =
    location.pathname === "/work/" || location.pathname === "/work";
  const showWhiteIcon = (isCourse || isWork) && selectedBgType !== "light";

  const isLesson = isCourse && lessonId;
  const isHomePage = location.pathname === "/";

  const isDarkBg = selectedBgType !== "light";

  const showSwitchAndName =
    gotUserInfo &&
    userInfo &&
    userInfo.userId &&
    !isWorkLeftPanelOpen &&
    (!((isCourse || isWork) && !isLessonEnd && !userClicked) || isLessonEnd);

  useEffect(() => {
    if (titleRef.current) {
      const { scrollWidth, clientWidth } = titleRef.current;
      setShowTooltip(scrollWidth > clientWidth);
    }
  }, [title]);

  return (
    <div className={styles.container}>
      {isMobileAndOldVersion() ? (
        <div
          className={cls({
            [styles.logo]: true,
            [styles.white]: showWhiteIcon,
          })}
        ></div>
      ) : (
        <>
          {" "}
          {(isHomePage && gotUserInfo && (!userInfo || !userInfo.userId)) ||
          isWorkLeftPanelOpen ? null : (
            <div
              className={styles.nav}
              onClick={() => {
                if (isCourse) {
                  window.location.href = `/courseinfo?courseId=${courseId}`;
                } else {
                  navigate(-1);
                }
              }}
            >
              <ArrowLeft className={styles.arrow}></ArrowLeft>
            </div>
          )}
        </>
      )}

      {showSwitchAndName && (
        <div className={styles.inner}>
          {!isMobileAndOldVersion() && (
            <Tooltip placement="bottom" title="打开侧栏">
              <button
                className={cls({
                  [styles.leftPanelSwitch]: true,
                  [styles.white]: showWhiteIcon,
                })}
                onClick={() => {
                  updateLeftPanelStatus(true);
                  setIsWorkLeftPanelOpen(true);
                }}
              ></button>
            </Tooltip>
          )}

          {(isCourse || isWork) && (
            <Divider
              type="vertical"
              style={{
                fontSize: 15,
                alignSelf: "center",
                borderColor: isDarkBg ? "white" : "#000000",
              }}
            />
          )}

          {isWork && <BtnAdd isLeftPanel={false} />}

          {isLesson && (
            <Flex vertical justify="center" className={styles.titleContainer}>
              <Tooltip placement="top" title={showTooltip ? title : ""}>
                <button
                  ref={titleRef}
                  className={styles.title}
                  onClick={() => {
                    if (!isMobileAndOldVersion())
                      window.location.href = `/courseinfo?courseId=${courseId}`;
                  }}
                  style={{
                    color: isDarkBg ? "white" : "black",
                  }}
                >
                  {title}
                </button>
              </Tooltip>
              <p
                className={styles.subTitle}
                style={{ color: isDarkBg ? "#F8F8F8" : "" }}
              >
                对话由 AI 生成
              </p>
            </Flex>
          )}
        </div>
      )}
    </div>
  );
}

export default LeftHeader;
